module.exports = __webpack_public_path__ + "img/mahindra-rise.ab48e19b.png";